import '../styles/invoice-0.scss';

window.addEventListener('DOMContentLoaded', () => {
    document.querySelector('.main__form').addEventListener('submit', (event) => {
        event.preventDefault();

        let isInvalid = false;

        for (let input of event.target.elements) {
            if (input.type === 'checkbox') {
                input.dispatchEvent(new Event('change'));

                if (input.required && !input.checked) {
                    isInvalid = true;
                }
            } else if (input.type === 'file') {
                if (input.files.length === 0) {
                    document.querySelector('.uploader').classList.add('uploader--invalid');
                }
            }
        }

        if (isInvalid) {
            document.querySelector('.agreements').classList.add('agreements--collapsed');
        }
    });
});